export const indexCopy = {
  index_2_headline:
    "TypeScript c'est <bold>JavaScript avec une syntaxe pour les types.</bold>",
  index_2_byline: "TypeScript améliore JavaScript en ajoutant des types.",
  index_2_summary:
    "TypeScript est un langage de programmation fortement typé qui s'appuie sur JavaScript et offre de meilleurs outils à n'importe quelle échelle.",

  // Above the fold
  index_2_cta_install: "Essayez TypeScript dès maintenant",
  index_2_cta_install_subtitle: "En ligne ou via npm",

  index_2_cta_play: "Dans votre navigateur",
  index_2_cta_play_subtitle: "via le playground",

  index_2_cta_download: "Sur votre ordinateur",
  index_2_cta_download_subtitle: "via npm",

  // Editor titles
  index_2_tab_1: "Vérifications de l'éditeur",
  index_2_tab_2: "Autocomplétion",
  index_2_tab_3: "Interfaces",
  index_2_tab_4: "JSX",
  index_2_tab_5: "ESNext",

  // Quick pitch
  index_2_what_is: "Qu'est-ce que TypeScript ?",
  index_2_what_is_js: "JavaScript et plus encore",

  index_2_what_is_js_copy: `TypeScript ajoute une syntaxe supplémentaire à JavaScript pour favoriser une <strong>intégration plus poussée avec votre éditeur</strong>. Détectez les erreurs au plus tôt dans votre éditeur.`,
  index_2_trust: "Un résultat digne de confiance",
  index_2_trust_copy: `Le code TypeScript peut être converti en JavaScript, qui <strong>peut être exécuté n'importe où où fonctionne JavaScript</strong> : dans un navigateur, sur Node.js ou Deno et dans vos applications.`,
  index_2_scale: "La sécurité à l'échelle",
  index_2_scale_copy: `TypeScript comprend le JavaScript et utilise <strong>l'inférence de type pour vous donner des outils de qualité</strong> sans code supplémentaire.`,

  // Links for getting started (this shows up twice)
  index_2_started_title: "Commencer",
  index_2_started_handbook: "Guide",
  index_2_started_handbook_blurb: "Apprendre le langage",
  index_2_install: "Installer TypeScript",
  index_2_playground_blurb: "Essayer dans votre navigateur",

  index_2_migrate_1: "Fichier JavaScript",
  index_2_migrate_2: "JavaScript avec vérification TS",
  index_2_migrate_3: "JavaScript avec JSDoc",
  index_2_migrate_4: "Fichier TypeScript",

  // Stories + OSS users`
  index_2_migration_title: "Témoignages TypeScript",
  index_2_migration_oss: "Open Source avec TypeScript",

  // Survey results
  index_2_loved_by: "Apprécié par les développeurs",
  index_2_loved_stack: `Élu <strong>2e langage de programmation le plus apprécié</strong> dans <so>l'enquête Stack Overflow 2020 Developer survey</so>.`,
  index_2_loved_state_js: `TypeScript a été <strong>utilisé par 78%</strong> des répondants à la <js>State of JS 2020</js>, avec <strong>93% disant qu'ils l'utiliseraient à nouveau</strong>.`,
  index_2_loved_state_js2: `TypeScript a reçu le prix de la <strong>"technologie la plus adoptée"</strong> sur la base de la croissance annuelle.`,

  // Show me some code
  index_2_describe: "Décrivez vos données",
  index_2_describe_blurb1:
    "<strong>Décrivez la forme des objets et des fonctions</strong> dans votre code.",
  index_2_describe_blurb2:
    "Permettant de voir la <strong>documentation et les problèmes dans votre éditeur</strong>.",

  // Show how tsc 'works'
  index_2_transform: "TypeScript devient JavaScript grâce à la touche de suppression.",
  index_2_transform_1: "<strong>Fichier TypeScript</strong>.",
  index_2_transform_2: "<strong>Les types sont retirés</strong>.",
  index_2_transform_3: "<strong>Fichier JavaScript</strong>.",

  // Adopt TS gradually animations
  index_2_adopt: "Adoptez TypeScript graduellement",
  index_2_adopt_blurb_1:
    "Appliquez des types à votre projet JavaScript progressivement, <strong>chaque étape améliore les capacités de votre éditeur</strong> et améliore votre codebase.",
  index_2_adopt_blurb_2:
    "Prenons ce code JavaScript incorrect, et voyons comment <strong>TypeScript peut détecter les erreurs dans votre éditeur</strong>.",

  index_2_adopt_info_1:
    "Pas d'avertissements de l'éditeur dans les fichiers JavaScript.<br/><br/>Ce code plante au moment de l'exécution.",
}
